import React from "react";

import HotelRating from "../HotelRating";
import HotelGeo from "./HotelGeo";

const renderEditorPick = () => (
  <p className="editor-pick">
    <span className="badge" data-icon="&#xe601;" aria-hidden="true" />
    <span className="sl no-mobile">
      Sélection <strong>Hôtel à Paris</strong>
    </span>
  </p>
);

const ResultListHeading = ({ hotel }) => {
  const blockKlasses = ["block-heading"];

  if (hotel.preferred) {
    blockKlasses.push("with-editor-pick");
  }

  return (
    <div className={blockKlasses.join(" ")}>
      <h2 className="h2">
        <a href={hotel.url} rel="external" itemProp="url">
          <span itemProp="name">{hotel.name}</span>
        </a>{" "}
        <HotelRating rating={hotel.rating} ratingText={hotel.ratingText} />
      </h2>

      <HotelGeo hotel={hotel} />
      {hotel.preferred === 1 && renderEditorPick()}
    </div>
  );
};

export default ResultListHeading;
